import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/service-conflic-alert";

export const getServiceConflicAlertById = serviceConflicAlertId => axios.get(API_PATH + "/get-by-id/"+ serviceConflicAlertId);

export const pagingServiceConflicAlert = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const saveServiceConflicAlert = serviceConflicAlert => axios.post(API_PATH + '/save-or-update', serviceConflicAlert);

export const deleteServiceConflicAlert = serviceConflicAlertId => axios.delete(API_PATH + '/mark-delete/' + serviceConflicAlertId)
